module.exports = __webpack_public_path__ + "img/logo_induban.13f6ffc6.png";